import React, { FC, memo, SyntheticEvent } from 'react';

import { Button } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './AuthSubmitButton.module.scss';
import { LoadingOutlined } from '@ant-design/icons';

interface AuthSubmitButtonProps {
    disabled: boolean;
    titleKey: string;
    onClick: (event: SyntheticEvent) => void | Promise<void>;
    isLimitedWidth?: boolean;
    confirmUserLoading?: boolean;
    'data-testid'?: string;
}

const AuthSubmitButton: FC<AuthSubmitButtonProps> = ({
    disabled, titleKey, onClick, isLimitedWidth = false, confirmUserLoading= false, 'data-testid': testId,
}) => {
    const { t } = useTranslation();

    return (
        <div className={styles.container}>
            <Button
                data-testid={testId}
                disabled={disabled}
                htmlType="submit"
                className={classNames(styles['login-button'], { [styles['limited-width']]: isLimitedWidth })}
                onClick={onClick}
                size="large"
            >
                {t(titleKey)}
                {confirmUserLoading && <LoadingOutlined className={styles.loader} spin />}
            </Button>
        </div>
    );
};

export default memo(AuthSubmitButton);
